import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SoftwareVersion } from '../model/softwareVersion.class';
import { Modal } from 'angular2-modal/plugins/bootstrap';

@Component({
    selector: 'app-software',
    templateUrl: './software.component.html'
})
export class SoftwareComponent {

    public message = '';
    public softwareVersions: SoftwareVersion[];
    public fileStati: string[];
    public selectedFileStatus: string;
    public fileToUpload : File;
    public softwareVersionUpload: SoftwareVersion;

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router, public modal: Modal) {
        this.fileStati = ["Test", "Gesperrt", "Freigegeben"];
        this.getSofwareVersions();
    }

    public getSofwareVersions() {
        this.userService.getAll('software').subscribe(data => {
            this.softwareVersions = data as SoftwareVersion[];
        });
    }

    public checkFileName(fileName: String) {
        if (fileName.startsWith("imageisoV") && fileName.endsWith(".iso")) {
            if (this.getVersionNumber(fileName) > -1) {
                return true;
            }
        }

        if (fileName.startsWith("firmwareV") && fileName.endsWith(".bin")) {
            if (this.getVersionNumber(fileName) > -1) {
                return true;
            }
        }
        return false;
    }

    public getVersionNumber(fileName: String) {
        let version = fileName.substring(fileName.indexOf('V') + 1, fileName.length);
        let versionNumber = parseInt(version);
        if (isNaN(versionNumber)) {
            return -1;
        }
        return versionNumber;
    }

    public fileChange(files: FileList): void {
        this.fileToUpload = files.item(0);
        this.softwareVersionUpload = new SoftwareVersion();
    }

    public uploadSoftware() {
        console.log(this.softwareVersionUpload)

        if (!this.checkUploadParameters()) {
            return;
        }

        let formData = new FormData();
        formData.append("file", this.fileToUpload)
        formData.append('properties', new Blob([JSON.stringify(this.softwareVersionUpload)], {
            type: "application/json"
        }));

        this.message = "Die Datei wird gerade hochgeladen. Dies kann je nach Größe etwas dauern."

        this.userService.create(formData, "software").subscribe(
            (data) => {
                this.message = "Die Datei wurde erfolgreich hochgeladen."
                this.clearUploadQueue()
                this.getSofwareVersions()
                console.log(data)
            },
            (err) => {
                this.message = "Das Hochladen der Datei ist fehlgeschlagen!"
                this.clearUploadQueue()
                console.log(err)
            });
    }

    public checkUploadParameters() {
        if (!this.checkFileName(this.fileToUpload.name)) {
            alert("Falscher Dateiname!");
            this.clearUploadQueue();
            return false;
        } 
        
        if (!this.softwareVersionUpload.description || !this.softwareVersionUpload.fileStatus) {
            alert("Beschreibung und Status der Datei sind zwingend erforderlich!");
            return false;
        }
        return true;
    }

    public clearUploadQueue() {
        this.fileToUpload = null;
        this.softwareVersionUpload = null;
    }

    public softwareStatusChanged(fileStatus: string, softwareVersion: SoftwareVersion) {
        this.modal.confirm()
            .size('sm')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .titleHtml('Status von dieser Software Version ändern?')
            .cancelBtn('Abbrechen')
            .open().then((resultPromise) => {
                return resultPromise.result.then(
                    (result) => {
                        softwareVersion.fileStatus = fileStatus;
                        this.userService.update(softwareVersion, 'software').subscribe();
                    },
                    () => {
                        console.log((<HTMLInputElement>document.getElementById(softwareVersion.softwareName)));
                        console.log((<HTMLInputElement>document.getElementById(softwareVersion.softwareName)).value);
                        (<HTMLInputElement>document.getElementById(softwareVersion.softwareName)).value = softwareVersion.fileStatus;
                     });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/software/software.component.ts